var _defs, _clipPath, _defs2, _mask, _g, _defs3, _clipPath2, _defs4, _mask2, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M8.711 17.232a.634.634 0 0 1-.658-.529c-.067-.413-.053-.993.057-1.551l-1.827-.369c-.159.627-.32 2.394.387 3.503a.174.174 0 0 0 .011.018c.332.51.85.876 1.641.922 1.33.214 3.512-.862 5.205-1.948a18.913 18.913 0 0 0 1.654-1.179l-.658-1.371c-2.215 1.293-3.973 2.401-5.812 2.504"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    overflow: "visible"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: 9.6,
    height: 4.8,
    x: 5.962,
    y: 14.727,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "f",
    width: 9.6,
    height: 4.8,
    x: 5.962,
    y: 14.727,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M4.961 8.772h13.913v11.923H4.961z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e",
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGTAAABwAAAAjj/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIABsAHwMBIgACEQEDEQH/ xAB8AAACAwEAAAAAAAAAAAAAAAAEBwABBgUBAQAAAAAAAAAAAAAAAAAAAAAQAAICAwEAAAAAAAAA AAAAAAQFAQIAIAYDEQACAQMBBQkAAAAAAAAAAAABAgMAEQQSECExIhMgQVFhcTJyFAUSAQAAAAAA AAAAAAAAAAAAACD/2gAMAwEAAhEDEQAAAGAEbyhb7Jc6YZdXAI2Q/9oACAECAAEFANP/2gAIAQMA AQUA0//aAAgBAQABBQDGrURUK/7Zo3so6i7LlseLaGjNFvqIYh5NyKvyYiY81AFCNf/aAAgBAgIG PwAf/9oACAEDAgY/AB//2gAIAQEBBj8ApsnKJsByou9mPgK6UROJiDhGhszb73ZhWblB9P6WDjSm T5pGzJIB522MCLm1NEFJ1HlAFyaz8+YmETYWREuKN7y9SJtII7uax2WPA19oxK849rsL6fTtf//Z",
    width: 29,
    height: 25,
    overflow: "visible",
    transform: "matrix(.48 0 0 .48 4.96 8.773)"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "g",
    width: 9.6,
    height: 4.8,
    x: 5.962,
    y: 14.727,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "j",
    d: "M5.962 14.727h9.218v4.714H5.962z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "k",
    width: 9.6,
    height: 4.8,
    x: 5.962,
    y: 14.727,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAGVAAABrAAAAev/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAA0AFwMBIgACEQEDEQH/ xACCAAACAwAAAAAAAAAAAAAAAAAAAgMEBgEBAQAAAAAAAAAAAAAAAAAAAQUQAAEDBQEAAAAAAAAA AAAAAAMCExQQARESBCIRAAECBAcAAAAAAAAAAAAAAAEAESExYTIQQQISIhMjEgABAgYDAAAAAAAA AAAAAAABABEQITFBkQISMhP/2gAMAwEAAhEDEQAAANWWmlMw5UP/2gAIAQIAAQUAjKex5//aAAgB AwABBQCn/9oACAEBAAEFADqXYwiE2ts30xXOaNT/2gAIAQICBj8AJ9dBryJ7Twme1V//2gAIAQMC Bj8Ah//aAAgBAQEGPwDWHI5Fo1QAJNFG5pL1fc2SPVdWeH//2Q==",
    width: 20,
    height: 10,
    overflow: "visible",
    transform: "matrix(.48 0 0 .48 5.962 14.727)"
  })))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "o",
    d: "M9.775 1.515C6.223 3.083 3.083 6.101 1.441 8.512L3.03 9.698c.045-.064 3.523-4.223 7.758-5.877 2.104-.823 4.398-1.026 6.55.203 2.827 1.814 1.477 8.35.033 11.278-2.522 5.114-7.553 6.14-9.731 5.738-2.178-.402-3.074-2.052-3.15-3.426-.167-3.063 2.462-5.916 3.003-6.438L5.6 9.821C1.628 13.82-.37 22.246 7.368 23.571c4.092.429 9.451-1.261 12.423-6.682 1.862-3.392 4.21-11.943-.958-15.115A8.147 8.147 0 0 0 14.354.462c-1.545 0-3.098.401-4.579 1.053"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o",
    overflow: "visible"
  }))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "p",
    width: 24.48,
    height: 24,
    x: -0.371,
    y: 0.462,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  })))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "v",
    width: 24.48,
    height: 24,
    x: -0.371,
    y: 0.462,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#p)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "r",
    d: "M-3.524-4.506h30.446v33.107H-3.524z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "s",
    clipPath: "url(#q)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "t",
    d: "M-3.527-4.505h30.448v33.107H-3.527z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "u",
    clipPath: "url(#s)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#t",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#u)"
  }, /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHIAAACLQAAAtH/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAEkAQwMBIgACEQEDEQH/ xACJAAEAAgIDAAAAAAAAAAAAAAAAAQMFBgIEBwEBAAAAAAAAAAAAAAAAAAAAABAAAQMEAgIDAAAA AAAAAAAAAwECBCARBQYAQBBQIRITEQACAQIEBAMJAAAAAAAAAAABAgMAESAhMQRRcRITgZGxEDBQ QdEyQiMFEgEAAAAAAAAAAAAAAAAAAABA/9oADAMBAAIRAxEAAAD0AwhlutqWbM1bTcSADXvOO1hz cdowu1l1vHkSADS8F6BJZ20kSAAFc8gkAAAAAAAAP//aAAgBAgABBQDs/wD/2gAIAQMAAQUA7P8A /9oACAEBAAEFAPBpAY7UyKEUZHO4lOc2SNjVFNPKLDdfgEu2jbtmZgogZRTlxqK7kIa2D8JRvpCP 2mGZGk12I47ARvojUtTvOvCklx2rqUuNgDgx6snH/d0OI0S1vYjla23o/wD/2gAIAQICBj8AT//a AAgBAwIGPwBP/9oACAEBAQY/APZ1SsFB0vqeQr9a5cW+grM4jtorS7w6p8o7i4L+eld2dzI51J9B woYljhIbf7gHsqc+hRrIw9OJ5GmllcvJIep3Y3JJ1JNChfFvFYkiMRKgP4r2kaw8WJoBsqDAXFDF F/TiIEz2hlS33AAlX8NPKlLLleljQWa2eOMHMLc250Db3APwT//Z",
    width: 64,
    height: 69,
    overflow: "visible",
    transform: "matrix(.48 0 0 .48 -3.527 -4.505)"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#q)",
    mask: "url(#v)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "w",
    width: 24.48,
    height: 24,
    x: -0.371,
    y: 0.462,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "B",
    d: "M-.371.462H24V24H-.371z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "D"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "C",
    width: 24.48,
    height: 24,
    x: -0.371,
    y: 0.462,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#D)"
  }, /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEAlgCWAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMA EAMCAwYAAAHlAAACLQAAAqr/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoX Hh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoa JjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIADQANAMBIgACEQEDEQH/ xACaAAEAAwEBAQAAAAAAAAAAAAAAAgMEAQUGAQEAAwEAAAAAAAAAAAAAAAAAAQMEBRAAAQMDBQAD AQAAAAAAAAAAAQACAxEEFBAgEyNEQDEyMxEAAQIEBQMFAAAAAAAAAAAAAAGhIBESQjHB0TKCEHEi IUFRgQISAAEBBQcFAAAAAAAAAAAAAAABEAIyM0NAESFxEpIDMUFRoYP/2gAMAwEAAhEDEQAAAPvK bs2VGuNfNm1SralS56WCeW04YAFovQj3lIIAWtLay8M4INBc3jtR/9oACAECAAEFAJ3OCknlrzzL mlV3chyrq41OmNKj9q3/ALL/2gAIAQMAAQUA+B//2gAIAQEAAQUAe8hOlkCdczBG8uFmXKzLlZU/ A8KQ0Tijr5nUpPIKk12eaWcokk7PM81O3zO/WwCpxDjHhr0rpXSulWePyL//2gAIAQICBj8Av1Km SmHI/uUmcm5SN+VfEvU0ut+IrYaPvxmUymOSou7P/9oACAEDAgY/ALB//9oACAEBAQY/APExZD0/ TIb2TQ3smhvZNCuryqlOSYS7R88ukkh55CoTWHnkLFzyF7wyTEpv3ffwLuYuYuYuYuY967apdP/Z",
    width: 51,
    height: 50,
    overflow: "visible",
    transform: "matrix(.48 0 0 .48 -.371 .462)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo-small.5320c80fdf5e8ccb883330ae6b3471ab.svg";
export { ForwardRef as ReactComponent };